export const formatDisplayName = (email) => {
  if (!email) return "";
  return email
    .split("@")[0]
    .split(".")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
